export default {"src":"/_next/static/media/icon_catalog_filtercross.ec0f855a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};